import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

// import { AppinfoService } from './../../../../common-services/appinfo.service';
// import { LbeSettingService } from './../../../../common-services/lbe-setting.service';
import { SubscriptionManagementService } from './../../../../common-services/subscription-management.service';

export interface SubLevel {
	name: string;
	value: string;
	id: number;
	idx: number;
}
export interface SliderChangeData {
	level: SubLevel;
	// value: number;
}

@Component({
	selector: 'app-sub-level-slider',
	templateUrl: './sub-level-slider.component.html',
	styleUrls: ['./sub-level-slider.component.css']
})
export class SubLevelSliderComponent implements OnInit, OnChanges {

	@Input() sliderIdx: number;
	// Disable user to change subscription level
	@Input() disableSlider: boolean;
	//
	@Output() sliderChange: EventEmitter<SliderChangeData> = new EventEmitter();
	//
	public subLevels: SubLevel[];
	constructor(
		private subManageService: SubscriptionManagementService
		// private appinfoService: AppinfoService,
		// private lbeSettingService: LbeSettingService
	) { }

	changeSliderValue() {
		this.sliderChange.emit({
			level: this.subLevels[this.sliderIdx],
			// value: this.sliderIdx
		});
	}
	getSliderValueByLevelValue(value: string) {
		return this.subLevels.findIndex((l) => l.value === value);
	}
	initSubLevels() {
		this.subLevels = this.subManageService.getSubscriptionLevels();
	}
	ngOnInit() {
		this.initSubLevels();
	}
	ngOnChanges(changes: SimpleChanges) {
		if (changes.sliderIdx.firstChange) {
			this.initSubLevels();
		}
		if (changes.sliderIdx) {
			this.changeSliderValue();
		}
	}

}



// WEBPACK FOOTER //
// ./src/app/components/portal/subscription-manage/sub-level-slider/sub-level-slider.component.ts